import { createApiClient, ApiError } from '@visep/api-sdk';

// baseUrl '' = mesma origem. O SDK já prefixa os paths com '/api/...', então
// '/api' aqui duplicaria. Dev: proxy do Vite (/api → :3001). Prod: Caddy.
const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

// Forms públicos batem em rotas `public:true` (CSRF guard faz skip) e não há
// cookie XSRF legível — getCsrfToken é irrelevante aqui.
export const api = createApiClient({
  baseUrl,
  getCsrfToken: () => null,
});

export { ApiError };
